export default "__VITE_ASSET__Cm00FeUr__"